const isUltraSim = (iccid) => {
  return (
    iccid.startsWith("8901260853") ||
    iccid.startsWith("89012401") ||
    iccid.startsWith("89012403")
  );
};

export { isUltraSim };
